export const srdRaces = [
    {
        "slug": "dwarf",
        "name": "Dwarf",
        "speed": 25,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "con",
                "bonus": 2
            }
        ],
        "alignment": "Most dwarves are lawful, believing firmly in the benefits of a well-ordered society. They tend toward good as well, with a strong sense of fair play and a belief that everyone deserves to share in the benefits of a just order.",
        "age": "Dwarves mature at the same rate as humans, but they're considered young until they reach the age of 50. On average, they live about 350 years.",
        "sizeDescription": "Dwarves stand between 4 and 5 feet tall and average about 150 pounds. Your size is Medium.",
        "languages": [
            "Common",
            "Dwarvish"
        ],
        "languageDescription": "You can speak, read, and write Common and Dwarvish. Dwarvish is full of hard consonants and guttural sounds, and those characteristics spill over into whatever other language a dwarf might speak.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Dwarven Resilience",
                "description": "You have advantage on saving throws against poison, and you have resistance against poison damage."
            },
            {
                "name": "Stonecunning",
                "description": "Whenever you make an Intelligence (History) check related to the origin of stonework, you are considered proficient in the History skill and add double your proficiency bonus to the check, instead of your normal proficiency bonus."
            },
            {
                "name": "Dwarven Combat Training",
                "description": "You have proficiency with the battleaxe, handaxe, light hammer, and warhammer."
            },
            {
                "name": "Tool Proficiency",
                "description": "You gain proficiency with the artisan's tools of your choice: smith's tools, brewer's supplies, or mason's tools."
            }
        ],
        "subraces": [
            {
                "name": "Hill Dwarf",
                "description": "As a hill dwarf, you have keen senses, deep intuition, and remarkable resilience.",
                "abilityBonuses": [
                    {
                        "ability": "wis",
                        "bonus": 1
                    }
                ],
                "traits": [
                    {
                        "name": "Dwarven Toughness",
                        "description": "Your hit point maximum increases by 1, and it increases by 1 every time you gain a level."
                    }
                ]
            }
        ]
    },
    {
        "slug": "elf",
        "name": "Elf",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "dex",
                "bonus": 2
            }
        ],
        "alignment": "Elves love freedom, variety, and self-expression, so they lean strongly toward the gentler aspects of chaos. They value and protect others' freedom as well as their own, and they are more often good than not.",
        "age": "Although elves reach physical maturity at about the same age as humans, the elven understanding of adulthood goes beyond physical growth to encompass worldly experience. An elf typically claims adulthood and an adult name around the age of 100 and can live to be 750 years old.",
        "sizeDescription": "Elves range from under 5 to over 6 feet tall and have slender builds. Your size is Medium.",
        "languages": [
            "Common",
            "Elvish"
        ],
        "languageDescription": "You can speak, read, and write Common and Elvish. Elvish is fluid, with subtle intonations and intricate grammar. Elven literature is rich and varied, and their songs and poems are famous among other races. Many bards learn their language so they can add Elvish ballads to their repertoires.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Fey Ancestry",
                "description": "You have advantage on saving throws against being charmed, and magic cannot put you to sleep."
            },
            {
                "name": "Trance",
                "description": "Elves do not need to sleep. Instead, they meditate deeply, remaining semiconscious, for 4 hours a day. (The Common word for such meditation is \"trance.\") While meditating, you can dream after a fashion; such dreams are actually mental exercises that have become reflexive through years of practice. After resting this way, you gain the same benefit that a human does from 8 hours of sleep."
            },
            {
                "name": "Keen Senses",
                "description": "You have proficiency in the Perception skill."
            }
        ],
        "subraces": [
            {
                "name": "High Elf",
                "description": "As a high elf, you have a keen mind and a mastery of at least the basics of magic. In many fantasy gaming worlds, there are two kinds of high elves. One type is haughty and reclusive, believing themselves to be superior to non-elves and even other elves. The other type is more common and more friendly, and often encountered among humans and other races.",
                "abilityBonuses": [
                    {
                        "ability": "int",
                        "bonus": 1
                    }
                ],
                "traits": [
                    {
                        "name": "Elf Weapon Training",
                        "description": "You have proficiency with the longsword, shortsword, shortbow, and longbow."
                    },
                    {
                        "name": "High Elf Cantrip",
                        "description": "You know one cantrip of your choice form the wizard spell list. Intelligence is your spellcasting ability for it."
                    },
                    {
                        "name": "Extra Language",
                        "description": "You can speak, read, and write one extra language of your choice."
                    }
                ]
            }
        ]
    },
    {
        "slug": "halfling",
        "name": "Halfling",
        "speed": 25,
        "size": "Small",
        "abilityBonuses": [
            {
                "ability": "dex",
                "bonus": 2
            }
        ],
        "alignment": "Most halflings are lawful good. As a rule, they are good-hearted and kind, hate to see others in pain, and have no tolerance for oppression. They are also very orderly and traditional, leaning heavily on the support of their community and the comfort of their old ways.",
        "age": "A halfling reaches adulthood at the age of 20 and generally lives into the middle of his or her second century.",
        "sizeDescription": "Halflings average about 3 feet tall and weigh about 40 pounds. Your size is Small.",
        "languages": [
            "Common",
            "Halfling"
        ],
        "languageDescription": "You can speak, read, and write Common and Halfling. The Halfling language isn't secret, but halflings are loath to share it with others. They write very little, so they don't have a rich body of literature. Their oral tradition, however, is very strong. Almost all halflings speak Common to converse with the people in whose lands they dwell or through which they are traveling.",
        "traits": [
            {
                "name": "Brave",
                "description": "You have advantage on saving throw against being frightened."
            },
            {
                "name": "Halfling Nimbleness",
                "description": "You can move through the space of any creature that is of a size larger than yours."
            },
            {
                "name": "Lucky",
                "description": "When you roll a 1 on the d20 for an attack roll, ability check, or saving throw, you can reroll the die and must use the new roll."
            }
        ],
        "subraces": [
            {
                "name": "Lightfoot Halfling",
                "description": "As a lightfoot halfling, you can easily hide from notice, even using other people as cover. You're inclined to be affable and get along well with others. Lightfoots are more prone to wanderlust than other halflings, and often dwell alongside other races or take up a nomadic life.",
                "abilityBonuses": [
                    {
                        "ability": "cha",
                        "bonus": 1
                    }
                ],
                "traits": [
                    {
                        "name": "Naturally Stealthy",
                        "description": "You can attempt to hide even when you are obscured only by a creature that is at least one size larger than you."
                    }
                ]
            }
        ]
    },
    {
        "slug": "human",
        "name": "Human",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "str",
                "bonus": 1
            },
            {
                "ability": "dex",
                "bonus": 1
            },
            {
                "ability": "con",
                "bonus": 1
            },
            {
                "ability": "int",
                "bonus": 1
            },
            {
                "ability": "wis",
                "bonus": 1
            },
            {
                "ability": "cha",
                "bonus": 1
            }
        ],
        "alignment": "Humans tend toward no particular alignment. The best and the worst are found among them.",
        "age": "Humans reach adulthood in their late teens and live less than a century.",
        "sizeDescription": "Humans vary widely in height and build, from barely 5 feet to well over 6 feet tall. Regardless of your position in that range, your size is Medium.",
        "languages": [
            "Common"
        ],
        "languageDescription": "You can speak, read, and write Common and one extra language of your choice. Humans typically learn the languages of other peoples they deal with, including obscure dialects. They are fond of sprinkling their speech with words borrowed from other tongues: Orc curses, Elvish musical expressions, Dwarvish military phrases, and so on.",
        "traits": [],
        "subraces": []
    },
    {
        "slug": "dragonborn",
        "name": "Dragonborn",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "str",
                "bonus": 2
            },
            {
                "ability": "cha",
                "bonus": 1
            }
        ],
        "alignment": "Dragonborn tend to extremes, making a conscious choice for one side or the other in the cosmic war between good and evil. Most dragonborn are good, but those who side with evil can be terrible villains.",
        "age": "Young dragonborn grow quickly. They walk hours after hatching, attain the size and development of a 10-year-old human child by the age of 3, and reach adulthood by 15. They live to be around 80.",
        "sizeDescription": "Dragonborn are taller and heavier than humans, standing well over 6 feet tall and averaging almost 250 pounds. Your size is Medium.",
        "languages": [
            "Common",
            "Draconic"
        ],
        "languageDescription": "You can speak, read, and write Common and Draconic. Draconic is thought to be one of the oldest languages and is often used in the study of magic. The language sounds harsh to most other creatures and includes numerous hard consonants and sibilants.",
        "traits": [
            {
                "name": "Draconic Ancestry",
                "description": "You have draconic ancestry. Choose one type of dragon from the Draconic Ancestry table. Your breath weapon and damage resistance are determined by the dragon type, as shown in the table."
            },
            {
                "name": "Breath Weapon",
                "description": "You can use your action to exhale destructive energy. Your draconic ancestry determines the size, shape, and damage type of the exhalation.\nWhen you use your breath weapon, each creature in the area of the exhalation must make a saving throw, the type of which is determined by your draconic ancestry. The DC for this saving throw equals 8 + your Constitution modifier + your proficiency bonus. A creature takes 2d6 damage on a failed save, and half as much damage on a successful one. The damage increases to 3d6 at 6th level, 4d6 at 11th level, and 5d6 at 16th level.\nAfter you use your breath weapon, you cannot use it again until you complete a short or long rest."
            },
            {
                "name": "Damage Resistance",
                "description": "You have resistance to the damage type associated with your draconic ancestry."
            }
        ],
        "subraces": []
    },
    {
        "slug": "gnome",
        "name": "Gnome",
        "speed": 25,
        "size": "Small",
        "abilityBonuses": [
            {
                "ability": "int",
                "bonus": 2
            }
        ],
        "alignment": "Gnomes are most often good. Those who tend toward law are sages, engineers, researchers, scholars, investigators, or inventors. Those who tend toward chaos are minstrels, tricksters, wanderers, or fanciful jewelers. Gnomes are good-hearted, and even the tricksters among them are more playful than vicious.",
        "age": "Gnomes mature at the same rate humans do, and most are expected to settle down into an adult life by around age 40. They can live 350 to almost 500 years.",
        "sizeDescription": "Gnomes are between 3 and 4 feet tall and average about 40 pounds. Your size is Small.",
        "languages": [
            "Common",
            "Gnomish"
        ],
        "languageDescription": "You can speak, read, and write Common and Gnomish. The Gnomish language, which uses the Dwarvish script, is renowned for its technical treatises and its catalogs of knowledge about the natural world.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Gnome Cunning",
                "description": "You have advantage on all Intelligence, Wisdom, and Charisma saving throws against magic."
            }
        ],
        "subraces": [
            {
                "name": "Rock Gnome",
                "description": "As a rock gnome, you have a natural inventiveness and hardiness beyond that of other gnomes.",
                "abilityBonuses": [
                    {
                        "ability": "con",
                        "bonus": 1
                    }
                ],
                "traits": [
                    {
                        "name": "Artificer's Lore",
                        "description": "Whenever you make an Intelligence (History) check related to magic items, alchemical objects, or technological devices, you can add twice your proficiency bonus, instead of any proficiency bonus you normally apply."
                    },
                    {
                        "name": "Tinker",
                        "description": "You have proficiency with artisan's tools (tinker's tools). Using those tools, you can spend 1 hour and 10 gp worth of materials to construct a Tiny clockwork device (AC 5, 1 hp). The device ceases to function after 24 hours (unless you spend 1 hour repairing it to keep the device functioning), or when you use your action to dismantle it; at that time, you can reclaim the materials used to create it. You can have up to three such devices active at a time.\nWhen you create a device, choose one of the following options:\nClockwork Toy: This toy is a clockwork animal, monster, or person, such as a frog, mouse, bird, dragon, or soldier. When placed on the ground, the toy moves 5 feet across the ground on each of your turns in a random direction. It makes noises as appropriate to the creature it represents.\nFire Starter: The device produces a miniature flame, which you can use to light a candle, torch, or campfire. Using the device requires your action.\nMusic Box: When opened, this music box plays a single song at a moderate volume. The box stops playing when it reaches the song's end or when it is closed."
                    }
                ]
            }
        ]
    },
    {
        "slug": "half-elf",
        "name": "Half-Elf",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "cha",
                "bonus": 2
            }
        ],
        "alignment": "Half-elves share the chaotic bent of their elven heritage. They value both personal freedom and creative expression, demonstrating neither love of leaders nor desire for followers. They chafe at rules, resent others' demands, and sometimes prove unreliable, or at least unpredictable.",
        "age": "Half-elves mature at the same rate humans do and reach adulthood around the age of 20. They live much longer than humans, however, often exceeding 180 years.",
        "sizeDescription": "Half-elves are about the same size as humans, ranging from 5 to 6 feet tall. Your size is Medium.",
        "languages": [
            "Common",
            "Elvish"
        ],
        "languageDescription": "You can speak, read, and write Common, Elvish, and one extra language of your choice.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Fey Ancestry",
                "description": "You have advantage on saving throws against being charmed, and magic cannot put you to sleep."
            },
            {
                "name": "Skill Versatility",
                "description": "You gain proficiency in two skills of your choice."
            }
        ],
        "subraces": []
    },
    {
        "slug": "half-orc",
        "name": "Half-Orc",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "str",
                "bonus": 2
            },
            {
                "ability": "con",
                "bonus": 1
            }
        ],
        "alignment": "Half-orcs inherit a tendency toward chaos from their orc parents and are not strongly inclined toward good. Half-orcs raised among orcs and willing to live out their lives among them are usually evil.",
        "age": "Half-orcs mature a little faster than humans, reaching adulthood around age 14. They age noticeably faster and rarely live longer than 75 years.",
        "sizeDescription": "Half-orcs are somewhat larger and bulkier than humans, and they range from 5 to well over 6 feet tall. Your size is Medium.",
        "languages": [
            "Common",
            "Orc"
        ],
        "languageDescription": "You can speak, read, and write Common and Orc. Orc is a harsh, grating language with hard consonants. It has no script of its own but is written in the Dwarvish script.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Savage Attacks",
                "description": "When you score a critical hit with a melee weapon attack, you can roll one of the weapon's damage dice one additional time and add it to the extra damage of the critical hit."
            },
            {
                "name": "Relentless Endurance",
                "description": "When you are reduced to 0 hit points but not killed outright, you can drop to 1 hit point instead. you cannot use this feature again until you finish a long rest."
            },
            {
                "name": "Menacing",
                "description": "You gain proficiency in the Intimidation skill."
            }
        ],
        "subraces": []
    },
    {
        "slug": "tiefling",
        "name": "Tiefling",
        "speed": 30,
        "size": "Medium",
        "abilityBonuses": [
            {
                "ability": "int",
                "bonus": 1
            },
            {
                "ability": "cha",
                "bonus": 2
            }
        ],
        "alignment": "Tieflings might not have an innate tendency toward evil, but many of them end up there. Evil or not, an independent nature inclines many tieflings toward a chaotic alignment.",
        "age": "Tieflings mature at the same rate as humans but live a few years longer.",
        "sizeDescription": "Tieflings are about the same size and build as humans. Your size is Medium.",
        "languages": [
            "Common",
            "Infernal"
        ],
        "languageDescription": "You can speak, read, and write Common and Infernal.",
        "traits": [
            {
                "name": "Darkvision",
                "description": "You have superior vision in dark and dim conditions. You can see in dim light within 60 feet of you as if it were bright light, and in darkness as if it were dim light. You cannot discern color in darkness, only shades of gray."
            },
            {
                "name": "Hellish Resistance",
                "description": "You have resistance to fire damage."
            },
            {
                "name": "Infernal Legacy",
                "description": "You know the thaumaturgy cantrip. When you reach 3rd level, you can cast the hellish rebuke spell as a 2nd-level spell once with this trait and regain the ability to do so when you finish a long rest. When you reach 5th level, you can cast the darkness spell once with this trait and regain the ability to do so when you finish a long rest. Charisma is your spellcasting ability for these spells."
            }
        ],
        "subraces": []
    }
];
